// extracted by mini-css-extract-plugin
module.exports = {"relatedContent":"motion_relatedContent__iLp9O"};